// saga.ts
import { call, put, takeEvery } from 'redux-saga/effects';
import { getDraftApi, updateDraft } from '../../api/DraftApi'; // Adjust the path as needed
import { getDraftSuccess, getDraftFailure, updateDraftSuccess, updateDraftFailure } from './actions';

// Saga to handle fetching Drafts
function* fetchDraftSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(getDraftApi, action.payload);
        yield put(getDraftSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(getDraftFailure(errorMessage));
    }
}

// // Saga to handle updating a Draft
function* updateDraftSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(updateDraft, action.payload.id);
        yield put(updateDraftSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';
        yield put(updateDraftFailure(errorMessage));
    }
}

// // Saga to handle updating a Draft
// function* deleteDraftSaga(action: any): Generator<any, any, any> {
//     try {
//         const data = yield call(deleteDraft, action.payload.id);
//         yield put(deleteDraftSuccess(data));
//     } catch (error: any) {
//         yield put(deleteDraftFailure(error.message));
//     }
// }

export default function* DraftSaga() {
    yield takeEvery('GET_DRAFT_REQUEST', fetchDraftSaga);
    // yield takeEvery('CREATE_DRAFT_REQUEST', createDraftSaga);
    yield takeEvery('UPDATE_DRAFT_REQUEST', updateDraftSaga);
    // yield takeEvery('DELETE_DRAFT_REQUEST', deleteDraftSaga);
}
